import * as React from 'react';

export const withProps = <OverridedProps extends {}>(overridedProps: OverridedProps) => {
  return <OwnProps extends {}>(
    Component: React.ComponentType<OwnProps>,
  ): React.ComponentType<Omit<OwnProps, keyof OverridedProps>> => {
    return class WithProps extends React.Component<OwnProps> {
      public render() {
        return (
          <Component
            {...this.props}
            {...overridedProps}
          />
        );
      }
    };
  };
};
